module.exports = __webpack_public_path__ + "static/media/grapher-cropped.197531da.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/grapher-cropped.PNG
// module id = 41
// module chunks = 0